<template>
  <VAutocomplete
    :model-value="selectedItemsIds"
    :placeholder="placeholder"
    :items="items"
    :multiple="true"
    :loading="loading"
    :disabled="disabled"
    :error-messages="errorMessage"
    variant="outlined"
    :item-title="'name'"
    :item-value="'id'"
    :rounded="'lg'"
    menu-icon="expand_more"
    hide-details
    @update:model-value="emit('selection-update', $event)"
  >
    <template #selection="{ item }">
      <VChip
        :variant="'flat'"
        :closable="true"
        class="bg-gray-300"
        density="compact"
        @click:close="emit('remove-item', item.raw.id)"
      >
        <p class="font-semibold">{{ item.raw.name }}</p>

        <template #close>
          <VIcon color="gray-800" icon="cancel" density="compact" />
        </template>
      </VChip>
    </template>

    <template #item="{ item, props }">
      <VListItem v-bind="{ ...props, title: undefined }">
        <div class="flex justify-space-between">
          <p class="font-semibold">{{ item.title }}</p>

          <VIcon v-if="selectedItemsIds.includes(item.value)" icon="check" color="primary" />
        </div>
      </VListItem>
    </template>
  </VAutocomplete>
</template>

<script setup lang="ts">
export interface Selectable {
  id: string
  name: string
}

interface Props {
  selectedItemsIds: string[]
  placeholder: string
  items: Selectable[]
  loading?: boolean
  disabled?: boolean
  errorMessage?: string
}

interface Emits {
  (e: 'remove-item', id: string): void
  (e: 'selection-update', id: string[]): void
}

const { items, selectedItemsIds } = defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<style scoped></style>
